// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1hBSw","list":"PatternAutocomplete_list__1m6GW"};